import { useEffect, useState } from 'react';
import { Toaster } from 'react-hot-toast';

const ShopToaster = () => {
  const [position, setPosition] = useState('top-right');

  useEffect(() => {
    const mq = window.matchMedia('(max-width: 639px)');
    const update = () => setPosition(mq.matches ? 'bottom-center' : 'top-right');
    update();
    mq.addEventListener('change', update);
    return () => mq.removeEventListener('change', update);
  }, []);

  return <Toaster position={position} />;
};

export default ShopToaster;
